import React from "react";
import { Code2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { DEVELOPER } from "@/data/contacts";
import { buildWhatsAppUrl } from "@/data/translations";

export default function DeveloperCredit() {
  const { t } = useLanguage();
  const D = t.devCredit;
  const msg =
    "Hi BOB Services LB, I found your website and I'd like to get in touch.";

  return (
    <div
      className="border-t border-white/10 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#737373]"
      data-testid="developer-credit"
    >
      <div className="flex items-center gap-2">
        <Code2 className="w-3.5 h-3.5 text-[#F37021]" />
        <span>
          {D.preLabel}{" "}
          <a
            href={buildWhatsAppUrl(msg, DEVELOPER.whatsapp)}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-white hover:text-[#F37021] transition-colors"
          >
            {D.name}
          </a>
        </span>
      </div>
      <a
        href={buildWhatsAppUrl(msg, DEVELOPER.whatsapp)}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 hover:text-[#F37021] transition-colors group"
        data-testid="developer-credit-cta"
      >
        <span>{D.cta}</span>
        <span className="text-[#F37021] font-medium">{D.waLabel}</span>
        <span aria-hidden className="group-hover:translate-x-0.5 transition-transform">→</span>
      </a>
    </div>
  );
}
